/*
 * Public API Surface of pepperi-lib/icon
 */
export * from './icon-registry.service';
export * from './icon.component';
export * from './icon.model';
export * from './icon.module';
